import { render, staticRenderFns } from "./KpisEnderecosExternosCards.vue?vue&type=template&id=1ed87a40&scoped=true&"
import script from "./KpisEnderecosExternosCards.vue?vue&type=script&lang=js&"
export * from "./KpisEnderecosExternosCards.vue?vue&type=script&lang=js&"
import style0 from "./KpisEnderecosExternosCards.vue?vue&type=style&index=0&id=1ed87a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed87a40",
  null
  
)

export default component.exports